import { useEffect } from "react";
import styles from "./style.module.scss";

import AnularFacturaIcon from '@assets/icons-png/anular-factura.png';
import EstadoCuentaIcon from '@assets/icons-png/estado-cuenta.png';
import CancelarFacturasIcon from '@assets/icons-png/cancelar-facturas.png';
import ReciboDineroIcon from '@assets/icons-png/recibo-dinero.png';
import NotasCreditoIcon from '@assets/icons-png/notas-credito.png';
import NotasDebitoIcon from '@assets/icons-png/notas-debito.png';
import LiquidacionesIcon from '@assets/icons-png/liquidaciones.png';
import AgregarDocumentoIcon from '@assets/icons-png/agregar-documento.png';
import ListaDocumentosIcon from '@assets/icons-png/lista-documentos.png';
import IconoMensajesTributacion from '@assets/icons-png/cropped_icons_with_padding/icon_69.png';
import IconoBackup from '@assets/icons-png/cropped_icons_with_padding/icon_98.png';
import SearchIcon from '@assets/icons-png/cropped_icons_with_padding/icon_6_6.png';
import RecieveDocumentIcon from '@assets/icons-png/cropped_icons_with_padding/icon_4_2.png';
import MonthReportIcon from '@assets/icons-png/month-report.png';
import AnualReportIcon from '@assets/icons-png/anual-report.png';
import ComisionesIcon from '@assets/icons-png/comisiones.png';
import ReportesIcon from '@assets/icons-png/reportes.png';
import PaqueteIcon from '@assets/icons-png/paquete.png';

import PageContainer from "@components/layout/PageContainer";
import DashboarLinksSection, { DashboardLinksSectionProps } from "@components/content/DashboardLinksSection";
import SendBackupToEmailOffCanvas from "@components/layout/Offcanvas/SendBackupToEmailOffCanvas";
import AccountingPackageOffCanvas from "@components/layout/Offcanvas/AccountingPackageOffCanvas";
import { OpenAccountingPackagePubSub, OpenSendBackupToEmailPubSub } from "@utils/pubsubs/PubSub";
import { useAppSelector } from "@/store/hooks";

const AccountingDashboard = () => {
  const suscriptionData = useAppSelector(store => store.suscription.suscription)
  const suscriptionEmail = suscriptionData?.email || ""
  const referenceLabel = suscriptionData?.reference_label || ""

  const groupLinks: DashboardLinksSectionProps[] = [
    {
      title: "Documentos Electronicos",
      links: [{
        icon: RecieveDocumentIcon,
        iconAlt: "Icono Recepcion Documentos Electronicos",
        title: "Recepcion Documentos Electronicos",
        url: "/user/receivedInvoices"
      }]
    },
    {
      title: "Cuentas por Cobrar",
      links: [{
        icon: AnularFacturaIcon,
        iconAlt: "Icono Anular Factura",
        title: "Anular Factura",
        url: "/user/invoices/cancel"
      },
      {
        icon: EstadoCuentaIcon,
        iconAlt: "Icono Estado de Cuenta",
        title: "Estado de Cuenta",
        url: "/user/clients/status"
      },
      {
        icon: CancelarFacturasIcon,
        iconAlt: "Icono Cancelar Facturas de Credito",
        title: "Cancelar Facturas de Credito",
        url: "/user/clients/payInvoices"
      },
      {
        icon: CancelarFacturasIcon,
        iconAlt: "Icono Agregar Recibo Manualmente",
        title: "Agregar Recibo Manualmente",
        url: "/user/clients/payInvoicesManually"
      },
      {
        icon: ReciboDineroIcon,
        iconAlt: "Icono Recibo de Dinero",
        title: "Recibo de Dinero",
        url: "/user/recibes"
      },
      {
        icon: NotasCreditoIcon,
        iconAlt: "Icono Notas de Credito",
        title: "Notas de Credito",
        url: "/user/creditnotes"
      },
      {
        icon: NotasDebitoIcon,
        iconAlt: "Icono Notas de Debito",
        title: "Notas de Debito",
        url: "/user/debitnotes"
      },
      {
        icon: LiquidacionesIcon,
        iconAlt: "Icono Liquidaciones",
        title: "Liquidaciones",
        url: "/user/settlements"
      }]
    },
    {
      title: "Cuentas por Pagar",
      links: [{
        icon: AgregarDocumentoIcon,
        iconAlt: "Icono Ingresar Factura",
        title: "Ingresar Factura",
        url: "/user/provider-invoices/invoice"
      },
      {
        icon: AgregarDocumentoIcon,
        iconAlt: "Icono Ingresar Factura e Inventorio",
        title: "Ingresar Factura e Inventorio",
        url: "/user/provider-Invoices/addWithInventory"
      },
      {
        icon: ListaDocumentosIcon,
        iconAlt: "Icono Lista Facturas",
        title: "Lista de Facturas",
        url: "/user/provider-Invoices"
      },
      {
        icon: EstadoCuentaIcon,
        iconAlt: "Icono Estado de Cuenta",
        title: "Estado de Cuenta",
        url: "/user/providers/status"
      },
      {
        icon: CancelarFacturasIcon,
        iconAlt: "Icono Cancelar Facturas",
        title: "Cancelar Facturas",
        url: "/user/providers/payInvoices"
      },
      {
        icon: ReciboDineroIcon,
        iconAlt: "Icono Recibo de Dinero",
        title: "Recibo de Dinero",
        url: "/user/provider-recibes"
      },
      {
        icon: AgregarDocumentoIcon,
        iconAlt: "Icono Validar Factura Electronica",
        title: "Validar Factura Electronica",
        url: "/user/provider-Invoices/validateEDocument"
      },
      {
        icon: AgregarDocumentoIcon,
        iconAlt: "Icono Validar Nota Credito Electronica",
        title: "Validar Nota Credito Electronica",
        url: "/user/provider-Invoices/notes/validateENote"
      },
      {
        icon: ListaDocumentosIcon,
        iconAlt: "Icono Lista Categorias",
        title: "Categorias de Compras",
        url: "/user/provider-invoices/categories"
      },
      {
        icon: NotasCreditoIcon,
        iconAlt: "Factura Electronica Compra",
        title: "Factura Electronica Compra",
        url: "/user/buyInvoices"
      },]
    },
    {
      title: "Registro de Gastos",
      links: [{
        icon: AgregarDocumentoIcon,
        iconAlt: "Icono Ingresar Gasto",
        title: "Ingresar Gasto",
        url: "/user/expenses/add"
      },
      {
        icon: ListaDocumentosIcon,
        iconAlt: "Icono Lista de Gastos",
        title: "Lista de Gastos",
        url: "/user/expenses"
      },
      {
        icon: ListaDocumentosIcon,
        iconAlt: "Icono Categorias de Gastos",
        title: "Categorias de Gastos",
        url: "/user/expenses/categories"
      },
      {
        icon: AgregarDocumentoIcon,
        iconAlt: "Icono Validar Factura Electronica",
        title: "Validar Factura Electronica",
        url: "/user/expenses/validateEDocument"
      },
      {
        icon: AgregarDocumentoIcon,
        iconAlt: "Icono Validar Nota Credito Electronica",
        title: "Validar Nota Credito Electronica",
        url: "/user/expenses/validateEDocumentNote"
      },
      {
        icon: NotasCreditoIcon,
        iconAlt: "Factura Electronica Compra",
        title: "Factura Electronica Compra",
        url: "/user/buyInvoiceExpenses"
      },]
    },
    {
      title: "Reportes Varios",
      links: [{
        icon: MonthReportIcon,
        iconAlt: "Icono Reporte Utilidad",
        title: "Reporte Utilidad",
        url: "/user/reports/utility"
      },
      {
        icon: MonthReportIcon,
        iconAlt: "Icono Reporte Cuentas Bancarias",
        title: "Reporte Cuentas Bancarias",
        url: "/user/reports/banks"
      },
      {
        icon: ComisionesIcon,
        iconAlt: "Icono Calculo Comision",
        title: "Calculo Comision",
        url: "/user/reports/comisions"
      },
      {
        icon: ReportesIcon,
        iconAlt: "Icono Reporte de Liquidaciones",
        title: "Reporte de Liquidaciones",
        url: "/user/reports/clientSettlements"
      },
      {
        icon: IconoMensajesTributacion,
        iconAlt: "Icono Lista Facturas",
        title: "Lista de Mensajes ATV",
        url: "/user/atv-messages"
      },
      {
        icon: IconoMensajesTributacion,
        iconAlt: "Icono Reporte Documentos Electronicos",
        title: "Documentos Electronicos",
        url: "/user/reports/edocuments"
      },
      {
        icon: IconoBackup,
        iconAlt: "Icono Backup",
        title: "Respaldo de Sistema",
        url: "#",
        onClick: () => {
          OpenSendBackupToEmailPubSub.publish({
            openOffCanvas: true,
            toEmail: suscriptionEmail
          })
        }
      },
      {
        icon: SearchIcon,
        iconAlt: "Icono Search",
        title: `Buscar Documentos Por ${referenceLabel}`,
        url: "/user/reports/searchByReference"
      },
      ]
    },
    {
      title: "Reportes Contables",
      links: [{
        icon: MonthReportIcon,
        iconAlt: "Icono Ventas Mensuales",
        title: "Ventas Mensuales",
        url: "/user/reports/sellByMonth"
      },
      {
        icon: AnualReportIcon,
        iconAlt: "Icono Ventas Anuales",
        title: "Ventas Anuales",
        url: "/user/reports/sellByYear"
      },
      {
        icon: MonthReportIcon,
        iconAlt: "Icono Compras Mensuales",
        title: "Compras Mensuales",
        url: "/user/reports/buyByMonth"
      },
      {
        icon: AnualReportIcon,
        iconAlt: "Icono Compras Anuales",
        title: "Compras Anuales",
        url: "/user/reports/buyByYear"
      },
      {
        icon: MonthReportIcon,
        iconAlt: "Icono Gastos Mensuales",
        title: "Gastos Mensuales",
        url: "/user/reports/expensesByMonth"
      },
      {
        icon: AnualReportIcon,
        iconAlt: "Icono Gastos Anuales",
        title: "Gastos Anuales",
        url: "/user/reports/expensesByYear"
      },
      {
        icon: PaqueteIcon,
        iconAlt: "Icono Paquete Contable Mensuales",
        title: "Paquete Contable Mensuales",
        url: "#",
        onClick: () => {
          OpenAccountingPackagePubSub.publish({
            openOffCanvas: true,
            mode: "month",
            toEmail: suscriptionEmail
          })
        }
      },
      {
        icon: PaqueteIcon,
        iconAlt: "Icono Paquete Contable Anuales",
        title: "Paquete Contable Anuales",
        url: "#",
        onClick: () => {
          OpenAccountingPackagePubSub.publish({
            openOffCanvas: true,
            mode: "year",
            toEmail: suscriptionEmail
          })
        }
      },
      ]
    },
  ]

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      title="Dashboard de Contabilidad"
      backUrl="/user/dashboard"
    >
      {
        groupLinks.map(gl => {
          return (
            <DashboarLinksSection
              isVisible={gl.isVisible}
              title={gl.title}
              links={gl.links}
            />
          )
        })
      }
      <SendBackupToEmailOffCanvas
      />
      <AccountingPackageOffCanvas
      />
    </PageContainer>
  );
}

export default AccountingDashboard;
